import { Component } from '@angular/core';
import { CoreIcon, ICON_TEMPLATE } from '@primeicons/angular/core';
import { spinner } from '@primeicons/core/spinner';

@Component({
    selector: 'svg[data-p-icon="spinner"]',
    standalone: true,
    template: ICON_TEMPLATE
})
export class Spinner extends CoreIcon {
    constructor() {
        super();
        this._icon = spinner;
    }
}
